__turbopack_context__.v({
  "bg-Aqua": "chip-module-scss-module__VLhGdW__bg-Aqua",
  "bg-BackgroundGray": "chip-module-scss-module__VLhGdW__bg-BackgroundGray",
  "bg-Berry": "chip-module-scss-module__VLhGdW__bg-Berry",
  "bg-Black": "chip-module-scss-module__VLhGdW__bg-Black",
  "bg-DarkAqua": "chip-module-scss-module__VLhGdW__bg-DarkAqua",
  "bg-DarkBerry": "chip-module-scss-module__VLhGdW__bg-DarkBerry",
  "bg-DarkGray": "chip-module-scss-module__VLhGdW__bg-DarkGray",
  "bg-DarkGreen": "chip-module-scss-module__VLhGdW__bg-DarkGreen",
  "bg-DarkMoss": "chip-module-scss-module__VLhGdW__bg-DarkMoss",
  "bg-DarkOrange": "chip-module-scss-module__VLhGdW__bg-DarkOrange",
  "bg-DarkRed": "chip-module-scss-module__VLhGdW__bg-DarkRed",
  "bg-DarkSmoke": "chip-module-scss-module__VLhGdW__bg-DarkSmoke",
  "bg-FadedAqua": "chip-module-scss-module__VLhGdW__bg-FadedAqua",
  "bg-FadedBerry": "chip-module-scss-module__VLhGdW__bg-FadedBerry",
  "bg-FadedGray": "chip-module-scss-module__VLhGdW__bg-FadedGray",
  "bg-FadedGreen": "chip-module-scss-module__VLhGdW__bg-FadedGreen",
  "bg-FadedMoss": "chip-module-scss-module__VLhGdW__bg-FadedMoss",
  "bg-FadedRed": "chip-module-scss-module__VLhGdW__bg-FadedRed",
  "bg-FadedSmoke": "chip-module-scss-module__VLhGdW__bg-FadedSmoke",
  "bg-Gray": "chip-module-scss-module__VLhGdW__bg-Gray",
  "bg-Green": "chip-module-scss-module__VLhGdW__bg-Green",
  "bg-LightAqua": "chip-module-scss-module__VLhGdW__bg-LightAqua",
  "bg-LightBerry": "chip-module-scss-module__VLhGdW__bg-LightBerry",
  "bg-LightGray": "chip-module-scss-module__VLhGdW__bg-LightGray",
  "bg-LightGreen": "chip-module-scss-module__VLhGdW__bg-LightGreen",
  "bg-LightMoss": "chip-module-scss-module__VLhGdW__bg-LightMoss",
  "bg-LightRed": "chip-module-scss-module__VLhGdW__bg-LightRed",
  "bg-LightSmoke": "chip-module-scss-module__VLhGdW__bg-LightSmoke",
  "bg-Moss": "chip-module-scss-module__VLhGdW__bg-Moss",
  "bg-Orange": "chip-module-scss-module__VLhGdW__bg-Orange",
  "bg-Red": "chip-module-scss-module__VLhGdW__bg-Red",
  "bg-Smoke": "chip-module-scss-module__VLhGdW__bg-Smoke",
  "bg-White": "chip-module-scss-module__VLhGdW__bg-White",
  "chip": "chip-module-scss-module__VLhGdW__chip",
  "clickable": "chip-module-scss-module__VLhGdW__clickable",
});
